/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import ImgixImage from './helpers/ev-imgix'

/**
 * The DOM representation of an asset.
 * @typedef {string} Asset
 */

/**
 * A React component that represents an asset, for example an image.
 *
 * @param {Object} params - The asset parameters.
 * @param {string} params.file - The file URL.
 * @param {string} [params.width='100%'] - The width of the asset.
 * @param {string} [params.sizes='100%'] - The sizes of the asset.
 * @returns {Asset}
 */
export default ({ file, sizes = '100%', maxWidth = '100%', title }) => (
  <ImgixImage src={file.url} sizes={sizes} sx={{ maxWidth, margin: '0 auto' }} alt={title} />
)
